export const RoomType = {
  pk1: 0,
  pk2: 1,
  pk3: 2,
  pk4: 3,
  pk5: 4,
  pk6: 5,
};
